import { render, staticRenderFns } from "./PostCommentForm.vue?vue&type=template&id=de0aee1c&scoped=true&"
import script from "./PostCommentForm.vue?vue&type=script&lang=js&"
export * from "./PostCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0aee1c",
  null
  
)

export default component.exports